import axios from 'axios'
import { apiUrl } from '@/api/base.js'

export default {
    join_document (args) {
        // return axios.get(`${apiUrl}v2/library/books/`, {params: args})
        return axios.post(`${apiUrl}v2/join_document/`, {params: args})
    },
    get_document_access(args){
         return axios.get(`${apiUrl}v2/get_document_access/`, {params: args})
    }
}